// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */

.rent_receipt p,
.verification_container p {
  margin-bottom: 0 !important;
}

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6rem;
  align-items: center;
}

.form_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.rent_receipt_container {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.rent_receipt {
  width: 100%;
  display: flex !important;
  flex-direction: column;
  gap: 1.75rem;
  border: 1px solid black;
  box-shadow: 1.5px 2.5px 1.5px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 1.5px 1.5px 2.5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1.5px 1.5px 2.5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 0.15rem;
  padding: 2rem;
  color: #9092a3;
  font-size: large;
  font-weight: 500;
}

.rent_receipt_header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.rent_receipt_header div {
  display: flex;
  flex-direction: column;
}

.rent_receipt_para {
  text-transform: uppercase;
  color: #314259;
  font-weight: 700;
  font-size: larger;
}

.rent_receipt_para span {
  color: #acacac;
  font-weight: 400;
  text-transform: capitalize;
  margin-left: 0.5rem;
}

.rent_receipt_footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

span {
  color: #77787b;
  font-weight: 700;
}

.form {
  padding: 2rem 3rem;
  width: 25rem;
  box-shadow: 3px 5px 3px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form2 {
  width: 35rem;
}

.submitButton {
  background: #7c22ba;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.7rem;
}

.rent_receipt_buttons_container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.printButton {
  font-weight: 600;
  width: 20rem;
  font-size: large;
  background: #7c22ba;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.4rem;
}

.inputContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.inputContainer .inputBox {
  width: 13rem;
}

.inputBox {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.label {
  color: #575757;
}

.input {
  border: none;
  border-bottom: 1px solid rgb(219, 219, 219);
  background: transparent;
  outline: none;
  height: 1.5rem;
  transition: height 0.5s ease;
}

.input_height {
  height: 3rem;
}

.inputError {
  color: red;
  font-weight: 600;
  margin-top: 0.3rem;
}

.otpError {
  color: red;
  font-weight: 600;
  margin-top: 0.3rem;
  width: 15rem;
}

.form2Buttons {
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.goBackButton {
  background: #575757;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.7rem;
}

.verification_container {
  padding: 2rem 3rem;
  width: 100%;
  box-shadow: 3px 5px 3px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
  background: #1f083c;
}

.verification {
  display: flex; /* Equivalent to 'flex' */
  align-items: center; /* Equivalent to 'items-center' */
  gap: 1rem; /* Equivalent to 'gap-4' (4 * 0.25rem = 1rem) */
  margin-top: 0.6rem;
}

.verification_container h2 {
  color: white;
  font-weight: 600;
  line-height: 1;
}

.otp_sent_para,
.otp_sent_para span {
  color: #c6bccd !important;
  display: inline;
  font-weight: 400;
}

.verification_metadata {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.verification_metadata p {
  display: inline;
  font-weight: 500;
  color: white;
  font-size: medium;
}

.resend_text {
  color: #c6bccd !important;
  font-weight: 400;
  margin-left: 0.7rem;
  cursor: pointer;
}

.otp {
  border: 1px solid; /* Equivalent to 'border' */
  width: 3rem; /* Equivalent to 'w-20' (20 * 0.25rem = 5rem) */
  height: 3rem; /* Equivalent to 'h-auto' */
  /* color: white; Equivalent to 'text-white' */
  padding: 0.75rem; /* Equivalent to 'p-3' (3 * 0.25rem = 0.75rem) */
  border-radius: 0.375rem; /* Equivalent to 'rounded-md' */
  background-color: #4c307a; /* Equivalent to 'bg-black' */
  outline: none; /* Equivalent to 'focus:outline-none' */
  appearance: none; /* Equivalent to 'appearance-none' */
  display: flex;
  align-items: center;
  justify-content: center;
}

.otp input {
  background: transparent;
  border: none;
  width: 100%;
  outline: none;
  color: white;
  font-size: large;
  font-weight: 600;
}

.otp_error {
  color: red;
  border: 2px solid red;
}

.otp input:focus {
  border-width: 2px; /* Equivalent to 'focus:border-2' */
}

.otp input[type="number"]::-webkit-outer-spin-button,
.otp input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp input[type="number"] {
  -moz-appearance: textfield;
}

.verification_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Hide the header and footer in the screen view */
.print-header,
.print-footer {
  display: none;
}

/* Display the header and footer in the print view */
@media print {
  .print-header,
  .print-footer {
    display: block;
  }

  .print-header {
    position: fixed;
    top: 0;
    right: 0;
    margin-top: 1rem;
    margin-right: 1rem;
    width: 100%;
    text-align: right;
    background: white;
  }

  .print-header span {
    margin-left: 3rem;
  }

  .print-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    margin-bottom: 1rem;
    margin-left: 1rem;
    width: 100%;
    text-align: left;
    background: white;
  }

  .print-body {
    page-break-before: auto;
    page-break-after: auto;
    page-break-inside: avoid;
  }

  .printable-content {
    margin-top: 80px;
  }
}

@media screen and (max-width: 475px) {
  .form_container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;
  }

  .form_container h4 {
    font-size: large;
  }

  .form_container li {
    font-size: small;
  }

  .form_container > div {
    width: 100%;
  }

  .form {
    padding: 1.5rem 2.5rem;
    width: 18rem;
  }

  .form2 {
    width: 20rem;
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .inputContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .inputContainer .inputBox {
    width: 15rem;
  }

  .goBackButton,
  .submitButton,
  .label {
    font-size: small;
  }

  .rent_receipt_container {
    width: 100%;
  }

  .rent_receipt_header {
    flex-direction: column;
  }

  .rent_receipt {
    font-size: small;
    padding: 1.5rem;
  }

  .rent_receipt_para {
    font-size: medium;
  }

  .rent_receipt_para span {
    font-size: smaller;
  }

  .rent_receipt_buttons_container {
    flex-direction: column;
  }

  .printButton {
    width: 16rem;
  }

  .verification_container h2 {
    font-size: large;
  }

  .otp_sent_para,
  .otp_sent_para span {
    color: #c6bccd !important;
    display: inline;
    font-weight: 400;
    font-size: small;
  }

  .verification_metadata p {
    font-size: smaller;
  }

  .verification_container {
    padding: 2rem 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/RentReceipt/rent-receipt-generator.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,qDAAqD;EACrD,6DAA6D;EAC7D,0DAA0D;EAC1D,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;EACpD,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;EACpD,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,yBAAyB;EACxC,mBAAmB,EAAE,iCAAiC;EACtD,SAAS,EAAE,+CAA+C;EAC1D,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,WAAW,EAAE,+CAA+C;EAC5D,YAAY,EAAE,2BAA2B;EACzC,6CAA6C;EAC7C,gBAAgB,EAAE,gDAAgD;EAClE,uBAAuB,EAAE,+BAA+B;EACxD,yBAAyB,EAAE,6BAA6B;EACxD,aAAa,EAAE,uCAAuC;EACtD,gBAAgB,EAAE,oCAAoC;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;;EAEE,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n} */\n\n.rent_receipt p,\n.verification_container p {\n  margin-bottom: 0 !important;\n}\n\n.container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6rem;\n  align-items: center;\n}\n\n.form_container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.rent_receipt_container {\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.rent_receipt {\n  width: 100%;\n  display: flex !important;\n  flex-direction: column;\n  gap: 1.75rem;\n  border: 1px solid black;\n  box-shadow: 1.5px 2.5px 1.5px 0px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: 1.5px 1.5px 2.5px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 1.5px 1.5px 2.5px 0px rgba(0, 0, 0, 0.75);\n  border-radius: 0.15rem;\n  padding: 2rem;\n  color: #9092a3;\n  font-size: large;\n  font-weight: 500;\n}\n\n.rent_receipt_header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.rent_receipt_header div {\n  display: flex;\n  flex-direction: column;\n}\n\n.rent_receipt_para {\n  text-transform: uppercase;\n  color: #314259;\n  font-weight: 700;\n  font-size: larger;\n}\n\n.rent_receipt_para span {\n  color: #acacac;\n  font-weight: 400;\n  text-transform: capitalize;\n  margin-left: 0.5rem;\n}\n\n.rent_receipt_footer {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\nspan {\n  color: #77787b;\n  font-weight: 700;\n}\n\n.form {\n  padding: 2rem 3rem;\n  width: 25rem;\n  box-shadow: 3px 5px 3px 0px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form2 {\n  width: 35rem;\n}\n\n.submitButton {\n  background: #7c22ba;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 0.7rem;\n}\n\n.rent_receipt_buttons_container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.printButton {\n  font-weight: 600;\n  width: 20rem;\n  font-size: large;\n  background: #7c22ba;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 0.4rem;\n}\n\n.inputContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.inputContainer .inputBox {\n  width: 13rem;\n}\n\n.inputBox {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.label {\n  color: #575757;\n}\n\n.input {\n  border: none;\n  border-bottom: 1px solid rgb(219, 219, 219);\n  background: transparent;\n  outline: none;\n  height: 1.5rem;\n  transition: height 0.5s ease;\n}\n\n.input_height {\n  height: 3rem;\n}\n\n.inputError {\n  color: red;\n  font-weight: 600;\n  margin-top: 0.3rem;\n}\n\n.otpError {\n  color: red;\n  font-weight: 600;\n  margin-top: 0.3rem;\n  width: 15rem;\n}\n\n.form2Buttons {\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.goBackButton {\n  background: #575757;\n  color: white;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 0.7rem;\n}\n\n.verification_container {\n  padding: 2rem 3rem;\n  width: 100%;\n  box-shadow: 3px 5px 3px 0px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin: 0 auto;\n  background: #1f083c;\n}\n\n.verification {\n  display: flex; /* Equivalent to 'flex' */\n  align-items: center; /* Equivalent to 'items-center' */\n  gap: 1rem; /* Equivalent to 'gap-4' (4 * 0.25rem = 1rem) */\n  margin-top: 0.6rem;\n}\n\n.verification_container h2 {\n  color: white;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.otp_sent_para,\n.otp_sent_para span {\n  color: #c6bccd !important;\n  display: inline;\n  font-weight: 400;\n}\n\n.verification_metadata {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.verification_metadata p {\n  display: inline;\n  font-weight: 500;\n  color: white;\n  font-size: medium;\n}\n\n.resend_text {\n  color: #c6bccd !important;\n  font-weight: 400;\n  margin-left: 0.7rem;\n  cursor: pointer;\n}\n\n.otp {\n  border: 1px solid; /* Equivalent to 'border' */\n  width: 3rem; /* Equivalent to 'w-20' (20 * 0.25rem = 5rem) */\n  height: 3rem; /* Equivalent to 'h-auto' */\n  /* color: white; Equivalent to 'text-white' */\n  padding: 0.75rem; /* Equivalent to 'p-3' (3 * 0.25rem = 0.75rem) */\n  border-radius: 0.375rem; /* Equivalent to 'rounded-md' */\n  background-color: #4c307a; /* Equivalent to 'bg-black' */\n  outline: none; /* Equivalent to 'focus:outline-none' */\n  appearance: none; /* Equivalent to 'appearance-none' */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.otp input {\n  background: transparent;\n  border: none;\n  width: 100%;\n  outline: none;\n  color: white;\n  font-size: large;\n  font-weight: 600;\n}\n\n.otp_error {\n  color: red;\n  border: 2px solid red;\n}\n\n.otp input:focus {\n  border-width: 2px; /* Equivalent to 'focus:border-2' */\n}\n\n.otp input[type=\"number\"]::-webkit-outer-spin-button,\n.otp input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.otp input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.verification_footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Hide the header and footer in the screen view */\n.print-header,\n.print-footer {\n  display: none;\n}\n\n/* Display the header and footer in the print view */\n@media print {\n  .print-header,\n  .print-footer {\n    display: block;\n  }\n\n  .print-header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    margin-top: 1rem;\n    margin-right: 1rem;\n    width: 100%;\n    text-align: right;\n    background: white;\n  }\n\n  .print-header span {\n    margin-left: 3rem;\n  }\n\n  .print-footer {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    margin-bottom: 1rem;\n    margin-left: 1rem;\n    width: 100%;\n    text-align: left;\n    background: white;\n  }\n\n  .print-body {\n    page-break-before: auto;\n    page-break-after: auto;\n    page-break-inside: avoid;\n  }\n\n  .printable-content {\n    margin-top: 80px;\n  }\n}\n\n@media screen and (max-width: 475px) {\n  .form_container {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem;\n  }\n\n  .form_container h4 {\n    font-size: large;\n  }\n\n  .form_container li {\n    font-size: small;\n  }\n\n  .form_container > div {\n    width: 100%;\n  }\n\n  .form {\n    padding: 1.5rem 2.5rem;\n    width: 18rem;\n  }\n\n  .form2 {\n    width: 20rem;\n    display: flex;\n    flex-direction: column;\n    gap: 3rem;\n  }\n\n  .inputContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 3rem;\n  }\n\n  .inputContainer .inputBox {\n    width: 15rem;\n  }\n\n  .goBackButton,\n  .submitButton,\n  .label {\n    font-size: small;\n  }\n\n  .rent_receipt_container {\n    width: 100%;\n  }\n\n  .rent_receipt_header {\n    flex-direction: column;\n  }\n\n  .rent_receipt {\n    font-size: small;\n    padding: 1.5rem;\n  }\n\n  .rent_receipt_para {\n    font-size: medium;\n  }\n\n  .rent_receipt_para span {\n    font-size: smaller;\n  }\n\n  .rent_receipt_buttons_container {\n    flex-direction: column;\n  }\n\n  .printButton {\n    width: 16rem;\n  }\n\n  .verification_container h2 {\n    font-size: large;\n  }\n\n  .otp_sent_para,\n  .otp_sent_para span {\n    color: #c6bccd !important;\n    display: inline;\n    font-weight: 400;\n    font-size: small;\n  }\n\n  .verification_metadata p {\n    font-size: smaller;\n  }\n\n  .verification_container {\n    padding: 2rem 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
